import * as ngSelect from '@ng-select/ng-select';

if(window['ng-select'] == null) window['ng-select'] = {};
window['ng-select']['ng-select'] = ngSelect

export { ngSelect };